import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { AjustePensionComponent } from './components/ajuste-pension/ajuste-pension.component';
import { AmpliacionSeguroLagunasComponent } from './components/ampliacion-seguro-lagunas/ampliacion-seguro-lagunas.component';
import { AumentoPguComponent } from './components/aumento-pgu/aumento-pgu.component';
import { BeneficiosCotizadosComponent } from './components/beneficios-cotizados/beneficios-cotizados.component';
import { CardBeneficiosComponent } from './components/card-beneficios/card-beneficios.component';
import { CardCapitalPlayComponent } from './components/card-capital-play/card-capital-play.component';
import { CompensacionMujeresComponent } from './components/compensacion-mujeres/compensacion-mujeres.component';
import { FechasClavesComponent } from './components/fechas-claves/fechas-claves.component';
import { HeaderConoceMasComponent } from './components/header-conoce-mas/header-conoce-mas.component';
import { HelpLinksComponent } from './components/help-links/help-links.component';
import { BeneficiosReformaPensionesComponent } from './components/beneficios-reforma-pensiones/beneficios-reforma-pensiones.component';
import { PrincipalesCambiosComponent } from './components/principales-cambios/principales-cambios.component';
import { ReformaPrevisionalContentComponent } from './components/reforma-previsional-content/reforma-previsional-content.component';
import { ConoceMasReformaComponent } from './pages/conoce-mas-reforma/conoce-mas-reforma.component';
import { DetalleBeneficioComponent } from './pages/detalle-beneficio/detalle-beneficio.component';
import { ReformaPensionesHomeComponent } from './pages/reforma-pensiones-home/reforma-pensiones-home.component';
import { ReformaPensionesRoutingModule } from './reforma-pensiones-routing.module';
import { TextSkeletonComponent } from './components/text-skeleton/text-skeleton.component';
import { CardImportanteComponent } from './components/card-importante/card-importante.component';
import { CompensacionMujeresChartComponent } from '../../assets/reforma-pensiones/icons/svg/compensacion-mujeres-chart/compensacion-mujeres-chart.component';
import { CompensacionMujeresChartOrientacionAbajoComponent } from 'src/assets/reforma-pensiones/icons/svg/compensacion-mujeres-chart-orientacion-abajo/compensacion-mujeres-chart-orientacion-abajo.component';
import { BeneficiosReformaFlechaMenuComponent } from 'src/assets/reforma-pensiones/icons/svg/beneficios-reforma-flecha-menu/beneficios-reforma-flecha-menu.component';
import { AmpliacionSeguroPersonaComponent } from 'src/assets/reforma-pensiones/icons/svg/ampliacion-seguro-persona/ampliacion-seguro-persona.component';
import { AmpliacionSeguroDocumentoComponent } from 'src/assets/reforma-pensiones/icons/svg/ampliacion-seguro-documento/ampliacion-seguro-documento.component';
import { AmpliacionSeguroAlcanciaComponent } from 'src/assets/reforma-pensiones/icons/svg/ampliacion-seguro-alcancia/ampliacion-seguro-alcancia.component';
import { BeneficiosAnosCotizadosInfografiaComponent } from 'src/assets/reforma-pensiones/icons/svg/beneficios-anos-cotizados-infografia/beneficios-anos-cotizados-infografia.component';
import { AjustePensionCalendarioComponent } from 'src/assets/reforma-pensiones/icons/svg/ajuste-pension-calendario/ajuste-pension-calendario.component';
import { AjustePensionTrendingDownComponent } from 'src/assets/reforma-pensiones/icons/svg/ajuste-pension-trending-down/ajuste-pension-trending-down.component';
import { AjustePensionBilleteraComponent } from 'src/assets/reforma-pensiones/icons/svg/ajuste-pension-billetera/ajuste-pension-billetera.component';
import { AjustePensionPguComponent } from 'src/assets/reforma-pensiones/icons/svg/ajuste-pension-pgu/ajuste-pension-pgu.component';
import { AumentoPguInfografiaComponent } from 'src/assets/reforma-pensiones/icons/svg/aumento-pgu-infografia-orientacion-derecha/aumento-pgu-infografia-orientacion-derecha';
import { AumentoPguInfografiaMobileComponent } from 'src/assets/reforma-pensiones/icons/svg/aumento-pgu-infografia-orientacion-abajo/aumento-pgu-infografia-orientacion-abajo.component';



@NgModule({
  declarations: [
    ReformaPensionesHomeComponent,
    CardBeneficiosComponent,
    DetalleBeneficioComponent,
    ConoceMasReformaComponent,
    HeaderConoceMasComponent,
    FechasClavesComponent,
    PrincipalesCambiosComponent,
    AumentoPguComponent,
    AjustePensionComponent,
    AmpliacionSeguroLagunasComponent,
    BeneficiosCotizadosComponent,
    CompensacionMujeresComponent,
    BeneficiosReformaPensionesComponent,
    CardCapitalPlayComponent,
    CardImportanteComponent,
    ReformaPrevisionalContentComponent,
    TextSkeletonComponent
  ],
  imports: [
    CommonModule,
    ReformaPensionesRoutingModule,
    IonicModule,
    SharedModule,
    HelpLinksComponent,
    AumentoPguInfografiaComponent,
    AumentoPguInfografiaMobileComponent,
    CompensacionMujeresChartComponent,
    CompensacionMujeresChartOrientacionAbajoComponent,
    BeneficiosReformaFlechaMenuComponent,
    AmpliacionSeguroPersonaComponent,
    AmpliacionSeguroDocumentoComponent,
    AmpliacionSeguroAlcanciaComponent,
    BeneficiosAnosCotizadosInfografiaComponent,
    AjustePensionCalendarioComponent,
    AjustePensionTrendingDownComponent,
    AjustePensionBilleteraComponent,
    AjustePensionPguComponent,
  ]
})
export class ReformaPensionesModule { }
